import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { orchestration } from '~/config/public';
import { logger } from '~/helpers/logger';

interface ResponseData {
  customerFinancing: CustomerFinancing;
}

interface CustomerFinancing {
  releasingPrice: ReleasingPrice;
}

export interface ReleasingPrice {
  registrationPlate: string;
  monthlyCost: number | null;
  monthlyCostStatus: 'VALID' | 'INVALID';
  message?: string[];
}

interface Data {
  status: number;
  price?: number;
  data: ReleasingPrice;
}

type GetReleasingCostInput = {
  price: number;
  regPlate: string;
  kmPerYear: string;
  isPrivate: boolean;
  leasingPeriodMonths: string;
};

const getReleasingCost = async ({
  regPlate,
  kmPerYear,
  leasingPeriodMonths,
  isPrivate,
  price
}: GetReleasingCostInput): Promise<Data> => {
  const url = new URL(`${orchestration.url}/auction/releasing/${regPlate}`);
  url.searchParams.append('leasing_period_months', leasingPeriodMonths);
  url.searchParams.append('km_per_year', kmPerYear);
  url.searchParams.append('price', price.toString());
  url.searchParams.append('is_private', isPrivate.toString());

  try {
    const { data, status } = await axios.get<ResponseData>(url.toString(), {
      responseType: 'json'
    });

    return {
      data: data?.customerFinancing?.releasingPrice,
      status,
      price
    };
  } catch (error) {
    logger.error(error.message, { error });
    return { ...error.response };
  }
};

export { getReleasingCost };
